'use client';

// npm packages
import React, { useEffect, useState, useCallback } from 'react';
import classNames from 'classnames';

// components
import { useDispatch, useSelector } from 'react-redux';
import { closeSuccessModal } from '@/redux/reducers/cart-modal-reducer';
import { removeCartItemsAsync } from '@/redux/thunk/carts-thunk';
import Text from '../Text';
import Icon from '../Icon';
import CartItemRemoveMessageAttributes from '../Cart/CartItemRemoveMessageAttributes';

function CartItemRemoveSuccessModal() {
  const dispatch = useDispatch();
  const { openItemRemoveSuccessModal, removeableItem: data } = useSelector(
    (state) => state.cartModal,
  );
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (openItemRemoveSuccessModal) {
      setTimeout(() => {
        setOpenModal(true);
      }, 100);
    } else {
      setOpenModal(false);
    }
  }, [openItemRemoveSuccessModal]);

  const handleClose = useCallback((closeState, closeData) => {
    setOpenModal(closeState);
  });

  useEffect(() => {
    if (openItemRemoveSuccessModal) {
      dispatch(removeCartItemsAsync({ id: data?.id }));
      setTimeout(() => {
        dispatch(closeSuccessModal({ type: 'item', data: null }));
      }, 5000);
    }
  }, [openItemRemoveSuccessModal]);

  return (
    <div
      className={classNames(
        'w-full h-full bg-transparent flex items-end justify-center opacity-30 fixed bottom-full left-0 right-0 transition-opacity duration-100',
        {
          '!bottom-0 !opacity-100 !z-[501]': openModal,
        },
      )}
    >
      <div
        className={classNames(
          `w-full sm:max-w-[500px] flex items-center justify-between gap-[6px] sm:gap-[16px] mx-8 lg:mx-0 mb-[90px] lg:mb-10 pl-16 pr-16 py-10 rounded-[4px] transition-all duration-[400ms]`,
          { 'bg-cape-verde': openModal },
        )}
      >
        <Text
          type="paragraph"
          className="text-aquarelle-purple text-14 font-encode-sans font-medium leading-20 tracking-[0.28px]"
        >
          <span className="!font-bold !tracking-[0.28px]">
            {' '}
            {data?.name?.en}{' '}
          </span>
          {data?.elements?.length > 0 && (
            <CartItemRemoveMessageAttributes data={data} />
          )}
          has been removed from the your cart.
        </Text>
        <div className="ml-4 lg:ml-0 size-[30px]">
          <Icon
            type="close"
            color="#fff"
            className="size-[24px] cursor-pointer"
            onClick={() => handleClose(false, '')}
          />
        </div>
      </div>
    </div>
  );
}

export default CartItemRemoveSuccessModal;
